package org.teddapp.project.db.repo

import app.cash.sqldelight.coroutines.asFlow
import app.cash.sqldelight.coroutines.mapToList
import com.tedd.db.Craving_observation
import com.tedd.db.TeddDatabase
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.withContext
import org.teddapp.project.db.TODAY_ISO
import org.teddapp.project.db.newId
import org.teddapp.project.db.nowMillis

/**
 * Observations d'habitudes. Céder est un fait, pas un échec : les deux issues sont
 * enregistrées. Une journée tenue sans envie ressentie est une observation aussi,
 * avec l'issue « validated » : c'est la même table, le même geste d'observer.
 */
class CravingRepository(private val db: TeddDatabase) {

    fun observeAll(): Flow<List<Craving_observation>> =
        db.cravingObservationQueries.selectAll().asFlow().mapToList(Dispatchers.Default)

    suspend fun record(
        habit: String,
        sensations: String,
        zones: List<String>,
        intensity: Int,
        crossed: Boolean,
        date: String = TODAY_ISO,
    ): String = withContext(Dispatchers.Default) {
        val id = newId("crav")
        val now = nowMillis()
        db.cravingObservationQueries.insert(
            id, habit.trim(), date, sensations.trim(), zones.joinToString(","),
            intensity.toLong().coerceIn(0L, 10L), if (crossed) "crossed" else "yielded", now, now,
        )
        id
    }

    /** Journée tenue sans envie ressentie : rien à traverser, la journée s'est passée. */
    suspend fun validate(habit: String, date: String = TODAY_ISO): String = withContext(Dispatchers.Default) {
        val id = newId("crav")
        val now = nowMillis()
        db.cravingObservationQueries.insert(id, habit.trim(), date, "", "", 0L, "validated", now, now)
        id
    }

    suspend fun softDelete(id: String) = withContext(Dispatchers.Default) {
        val now = nowMillis()
        db.cravingObservationQueries.softDelete(now, now, id)
    }
}
